import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
  import { LocalisationService } from 'app/core/services/localisation/zuper.localisation.service';

export interface PopupContent {
  title: string;
  description: string;
  popupIconType?: string;
  buttons: {
    primaryBtn: {
      displayName: string;
      displayKey: string;
      icon?: string;
      showIf?: boolean;
    };
    secondaryBtn?: {
      displayName: string;
      displayKey: string;
      icon?: string;
      showIf?: boolean;
    };
  };
}

@Component({
  selector: 'app-created-popup',
  templateUrl: './created-popup.component.html',
  styleUrls: ['./created-popup.component.scss']
})
export class CreatedPopupComponent implements OnInit {
  popupContent: PopupContent;

  constructor(
    private localisationService: LocalisationService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<CreatedPopupComponent>,) { }

  ngOnInit(): void {
    this.localisationService.setDefaultLanguage();
    this.popupContent = this.data.data;
  }

  handleButtonClick(value): void{
    this.dialogRef.close({
      emitKey: value
    });
  }

  closePopup(): void{
    this.dialogRef.close({
      emitKey: ''
    });
  }

}
